import { FC } from 'react';
import styled from 'styled-components';
import { ErrorMessage, InputLabel } from '../input';
import { DropDown, IDropDown } from './base';

type IDropDownWithLabel = IDropDown & {
  label: string;
  className?: string;
  errorMessage?: string;
};
export const DropDownWithLabel: FC<IDropDownWithLabel> = ({
  label,
  className,
  errorMessage,
  ...rest
}) => {
  return (
    <Container className={className}>
      <InputLabel>{label}</InputLabel>
      <CustomDropDown {...rest} />
      {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const CustomDropDown = styled(DropDown)`
  margin-top: 8px;
  background: #fafafa;
  border: 1px solid #d6d6d6;
  box-sizing: border-box;
  border-radius: 8px;
`;
